// src/app/sorting/sortable-column.ts
import { MatSort, Sort } from '@angular/material/sort';
export class SortableColumn {
    name: string;
    title: string;
    direction: string;
   
    public constructor(name: string, title: string, direction: string) {
      this.name = name;
      this.title = title;
      this.direction = direction;
    }

    public toggleDirection() {
        if(this.direction == 'desc') {
          this.direction = null;
        } else if(this.direction == 'asc') {
          this.direction = 'desc';
        } else {
          this.direction = 'asc';
        }
      }

     
      
      sortTableData(sort: Sort, dataSourceArray:any[] , tableColumns: any[]): boolean | Array<any> {
        const data = dataSourceArray.slice();
        if (!sort.active || sort.direction === '') {
          return false;
        }
       let sortedData: any[];
       sortedData = data.sort((a, b) => {
          const isAsc = sort.direction === 'asc';
          if (tableColumns.find(columnName => columnName == sort.active)) {
            return this.compare((a[sort.active]!==null && a[sort.active]!==undefined) ? a[sort.active]: "",
                                (b[sort.active]!==null && b[sort.active]!==undefined) ? b[sort.active]: "",
                                isAsc);
          } else {
            return 0;
          }
        });
        return sortedData;
      }
      
      compare(a: number | string | Date, b: number | string| Date, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
      }
      
  }